export type PackageTypeOrSizeMode = "type" | "size" | "none";

/**
 * Type and Size are mutually exclusive on the create-order item row. Other
 * surfaces keep Type-only (no Size on the item) until their slices convert.
 * A failed fetch still shows Type so we do not fall through to Size.
 */
export function packageTypeOrSizeMode({
  hasBasePackage,
  packageTypes,
  arePackageTypesResolved = true,
  packageTypesError,
}: {
  hasBasePackage?: boolean;
  packageTypes?: { id: string }[] | null;
  arePackageTypesResolved?: boolean;
  packageTypesError?: string | null;
}): PackageTypeOrSizeMode {
  if (packageTypesError) return "type";
  if (!arePackageTypesResolved) return "none";
  if ((packageTypes?.length ?? 0) > 0) return "type";
  if (hasBasePackage) return "size";
  return "none";
}
